import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpReqService } from '@api/services/http-req/http-req.service';
import { Observable } from 'rxjs';

export interface ReqErrorConfigModel {
  showError: boolean;
  defaultMessage: string;
}

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private httpReqService: HttpReqService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const reqCopy = req.clone({
      headers: this.httpReqService.setHeadersOnHttpRequest(req)
    });

    return next.handle(reqCopy);
  }
}
